import React from 'react';
import { ILayoutContext } from './type';

export const LayoutContext = React.createContext<ILayoutContext>({
  frameType: null,
  currentMenu: null,
  metricConfig: null,
});
LayoutContext.displayName = 'LayoutContext';
